import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LOCAL_DATA_RESET_ROUTE, SERVICE_WORKER_RESET_ROUTES } from '@modules/reset-state/reset-local-data';

const routes: Routes = [
  {
    path: 'unauthorized',
    loadChildren: () =>
      import('@modules/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
  },
  {
    path: LOCAL_DATA_RESET_ROUTE,
    loadComponent: () =>
      import('@modules/reset-state/reset-state.component').then(m => m.ResetStateComponent),
  },
  // Includes the deprecated `deregister-sw` alias — see SERVICE_WORKER_RESET_ROUTES.
  ...SERVICE_WORKER_RESET_ROUTES.map(path => ({
    path,
    loadComponent: () =>
      import('@modules/reset-state/reset-state.component').then(m => m.ResetStateComponent),
  })),
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 56],
      enableTracing: false,
    }),
  ],
  exports: [ RouterModule ],
})
export class AppRoutingModule {}
